var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { createElement, memo, useContext, useMemo, useState, useEffect, useCallback, useRef } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import Image from '@hfe/max-image';
import LImage from '@max/leez-image';
import RecyclerView from '@hfe/max-recyclerview';
import ScrollView from '@hfe/max-scrollview';
import './index.scss';
import { p2runit } from '@hfe/max-universal-unit-tool';
import { navigateTo } from '@max/meituan-uni-navigate';
import { getCityInfo } from '@max/meituan-uni-city';
import { useUserInfo } from './lib/hooks/useGetUserInfo';
import { get } from './lib/request';
import { host } from './config/host';
import { getFlightListUrl, getFlightOTAUrl, isMTWX } from './lib/redirect';
import FlightTheme2 from './components/single/flightTheme2';
import FlightTheme3 from './components/single/flightTheme3';
import FlightTheme4 from './components/single/flightTheme4';
import FlightTheme7 from './components/single/flightTheme7';
import Recommend1 from './components/single/recommend1';
import Recommend2 from './components/single/recommend2';
import Recommend3 from './components/single/recommend3';
import Recommend4 from './components/single/recommend4';
import Recommend5 from './components/single/recommend5';
import FlightRound from './components/round/flightRound';
import FlightTransit from './components/transit';
import Empty from './components/empty';
import { CLICK_CARD_MC_BID, FLIGHT_SPECIAL_PRICE_ROOT_MV, SHOW_MORE_MC_BID, SWITCH_CONTENT_MC_BID } from './lib/constant';
/* 工具函数：生成间距样式 */
const createSpacingStyle = (spacing, type) => {
    const prefix = type === 'margin' ? 'margin' : 'padding';
    return {
        [`${prefix}Top`]: p2runit(spacing.top),
        [`${prefix}Right`]: p2runit(spacing.right),
        [`${prefix}Bottom`]: p2runit(spacing.bottom),
        [`${prefix}Left`]: p2runit(spacing.left)
    };
};
const week = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
const MyComponent = (props) => {
    var _a, _b, _c, _d, _e, _f, _g;
    // 从全局变量global取Context
    const ctx = useContext(global._EngineGlobalContext);
    const { _LXReport } = ctx;
    // 调用引擎注入的自定义API
    const { mode, headerConfig, uiSpecial, titleConfig, theme, apiConfig, quoteType, sourceSwitch, cornerConfig, stylesConfig } = props;
    const [singleFlightList, setSingleFlightList] = useState([]);
    const [singleInfo, setSingleInfo] = useState([]);
    const [recommendFlightList, setRecommendFlightList] = useState([]);
    const [transitFlightList, setTransitFlightList] = useState([]);
    const [goFlightList, setGoFlightList] = useState([]);
    const [index, setIndex] = useState(apiConfig.count);
    const [foldSingleInfo, setFoldSingleInfo] = useState([]);
    const [selectCity, setSelectCity] = useState(null);
    const [isFoldUp, setIsFoldUp] = useState(false);
    const [bottomBtnStyle, setBottomBtnStyle] = useState({});
    const [isNowEmpty, setIsNowEmpty] = useState(false);
    const [recommendScene, setRecommendScene] = useState(0);
    const [recommendSceneTip, setRecommendSceneTip] = useState('');
    // 添加请求锁，防止重复请求
    const prevRequestParams = useRef('');
    const cityChanged = useCallback((params) => {
        console.log('flight-special-price::cityChanged', params);
        setSelectCity(params.value);
    }, [apiConfig, selectCity]);
    // 获取当前环境中的接口host
    const currentHost = host('online');
    const toast = (content) => {
        ctx._uiInteractionAPI.toast.show({
            content: content
        });
    };
    // 获取用户信息
    const { userInfo } = useUserInfo(false);
    // 是否展示头部
    const show = useMemo(() => {
        return headerConfig.showHeader;
    }, [headerConfig.showHeader]);
    // 头部样式处理
    const headerStyle = useMemo(() => {
        return Object.assign(Object.assign({ position: 'relative', width: '100%', overflow: 'hidden' }, createSpacingStyle(headerConfig.contentMargin, 'margin')), createSpacingStyle(headerConfig.contentPadding, 'padding'));
    }, [headerConfig.contentMargin, headerConfig.contentPadding]);
    const padding = useMemo(() => {
        if (theme === 4) {
            return '18rpx';
        }
        else if (theme === 2 || theme === 3) {
            return '24rpx';
        }
        else {
            return '20rpx';
        }
    }, [theme]);
    // 容器样式处理
    const containerStyle = useMemo(() => {
        const { leftTop = 0, rightTop = 0, rightBottom = 0, leftBottom = 0 } = (uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btBorderRadius) || {};
        return {
            backgroundColor: titleConfig.background || 'transparent',
            padding: padding,
            borderTopLeftRadius: p2runit(leftTop),
            borderTopRightRadius: p2runit(rightTop),
            borderBottomRightRadius: p2runit(rightBottom),
            borderBottomLeftRadius: p2runit(leftBottom)
        };
    }, [uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btBorderRadius]);
    const getSwitchImg = useMemo(() => {
        if (uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.needJump) {
            return 'https://p0.meituan.net/travelcube/5b23fab0229f9acc296545705017cce91623.png@42w_42h_80q';
        }
        else {
            return 'https://p1.meituan.net/travelcube/265b6398e38692dcdd65b89c7c24d3d81190.png@28w_28h_80q';
        }
    }, [uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.needJump]);
    const getshowMoreTitle = useMemo(() => {
        var _a, _b;
        if (isFoldUp) {
            return ((_a = uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btnTitleConfig) === null || _a === void 0 ? void 0 : _a.foldUpWord) || '';
        }
        else {
            return ((_b = uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btnTitleConfig) === null || _b === void 0 ? void 0 : _b.foldDownWord) || '';
        }
    }, [isFoldUp]);
    const routeConfig_recommendType = useMemo(() => {
        var _a;
        return ((_a = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeConfig) === null || _a === void 0 ? void 0 : _a.config) || 0;
    }, [apiConfig]);
    const isNameTooLong = useMemo(() => {
        if (foldSingleInfo && foldSingleInfo.length > 0) {
            return foldSingleInfo.some((item) => item.departCityName.length + item.arriveCityName.length > 7);
        }
        else {
            return false;
        }
    }, [foldSingleInfo]);
    const showBottomBtn = useMemo(() => {
        return (uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.isShowFoldDown) && singleInfo.length > ((uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.defaultCount) || 0) && ((uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.isShowFoldDown) && !isFoldUp || (uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.isShowFoldUp) && isFoldUp);
    }, [uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.isShowFoldDown, uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.isShowFoldUp, uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.defaultCount, singleInfo.length, isFoldUp]);
    const change = () => {
        var _a, _b;
        const tag = {
            custom: {
                component_name: '机票往返特价组件',
                class_title: '换一换',
                bu_code: 'traffic' // 区分业务BU，按实际业务上报
            }
        };
        (_b = (_a = ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mcReport) === null || _b === void 0 ? void 0 : _b.call(_a, SWITCH_CONTENT_MC_BID, {
            valLab: tag
        });
        if ((uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.needJump) && uiSpecial.jumpLink && theme === 4) {
            // this.$call(this.uiSpecial.jumpLink)
            navigateTo({
                url: uiSpecial.jumpLink
            });
            return;
        }
        // 学生特价数据
        if (index + apiConfig.count > singleFlightList.length) {
            let fill = apiConfig.count - (singleFlightList.length - index);
            setSingleInfo(singleFlightList.slice(index).concat(singleFlightList.slice(0, fill)));
            setIndex(fill);
        }
        else {
            let next = index + apiConfig.count;
            setSingleInfo(singleFlightList.slice(index, next));
            setIndex(next);
        }
    };
    const showMore = () => {
        var _a, _b;
        const tag = {
            custom: {
                component_name: '机票往返特价组件',
                class_title: isFoldUp ? '收起' : '查看更多',
                bu_code: 'traffic' // 区分业务BU，按实际业务上报
            }
        };
        (_b = (_a = ctx._LXReport) === null || _a === void 0 ? void 0 : _a.mcReport) === null || _b === void 0 ? void 0 : _b.call(_a, SHOW_MORE_MC_BID, {
            valLab: tag
        });
        setIsFoldUp(!isFoldUp);
        setDivSize();
    };
    const setDivSize = () => {
        var _a, _b, _c, _d, _e;
        const imageUrl = getshowMoreBackImage();
        if (imageUrl && imageUrl.length > 0) {
            setBottomBtnStyle({
                backgroundImage: `url(${imageUrl})`,
                width: '100%',
                height: p2runit(((_b = (_a = uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btnTitleConfig) === null || _a === void 0 ? void 0 : _a.btnHeight) !== null && _b !== void 0 ? _b : 0) / 2),
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
            });
        }
        else {
            setBottomBtnStyle({
                height: p2runit(((_d = (_c = uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btnTitleConfig) === null || _c === void 0 ? void 0 : _c.btnHeight) !== null && _d !== void 0 ? _d : 0) / 2),
                backgroundColor: ((_e = uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btnTitleConfig) === null || _e === void 0 ? void 0 : _e.bgColor) || '#ffffff',
                borderRadius: p2runit(24)
            });
        }
    };
    const getshowMoreBackImage = () => {
        var _a, _b;
        if (isFoldUp) {
            return ((_a = uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btnTitleConfig) === null || _a === void 0 ? void 0 : _a.foldUpImg) || '';
        }
        else {
            return ((_b = uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btnTitleConfig) === null || _b === void 0 ? void 0 : _b.foldDownImg) || '';
        }
    };
    const getWeek = (date) => {
        let y = date.substr(0, 4), m = date.substr(5, 2), d = date.substr(8, 2);
        return week[new Date(Number(y), Number(m) - 1, Number(d)).getDay()];
    };
    const flightInfoAdapter = (directFlight) => {
        let obj = {};
        obj.departCityName = directFlight.departCityName;
        obj.departCityCode = directFlight.departCityCode;
        obj.arriveCityName = directFlight.arriveCityName;
        obj.arriveCityCode = directFlight.arriveCityCode;
        obj.date = directFlight.flightDate;
        obj.week = getWeek(directFlight.flightDate);
        obj.price = directFlight.price;
        obj.discout = Math.round(directFlight.discount);
        obj.picurl = directFlight.cityPicture;
        obj.bigPicurl = directFlight.cityPicture;
        obj.flightNumber = directFlight.flightNumber;
        obj.departTime = directFlight.departTime;
        obj.extendData = directFlight.extendData;
        obj.jumpData = directFlight.jumpData;
        return obj;
    };
    const isNumeric = (str) => {
        return /^-?\d+\.?\d*$/.test(str);
    };
    const getGetAPI = () => __awaiter(void 0, void 0, void 0, function* () {
        var _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35;
        try {
            // 初始化数据
            setSingleFlightList([]);
            setRecommendFlightList([]);
            let carrierLimitList = null;
            let departCityLimitList = null;
            let arriveCityLimitList = null;
            let transitCityLimitList = null;
            let locatingCityId = 0;
            let selectedArriveCityId = 0;
            let recommendType = 0;
            let hotLineType = 1;
            let cProductCodeList = null;
            if (((_h = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeConfig) === null || _h === void 0 ? void 0 : _h.config) === 0) {
                // 航线推荐配置
                recommendType = 0;
                if (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeSuggest) {
                    carrierLimitList = ((_j = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeSuggest) === null || _j === void 0 ? void 0 : _j.carrierList) || '';
                }
            }
            else if (((_k = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeConfig) === null || _k === void 0 ? void 0 : _k.config) === 1) {
                // 目的地推荐
                recommendType = 1;
                if (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) {
                    carrierLimitList = ((_l = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _l === void 0 ? void 0 : _l.carrierList) || '';
                    if ((_m = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _m === void 0 ? void 0 : _m.departCity) {
                        departCityLimitList = ((_p = (_o = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _o === void 0 ? void 0 : _o.departCity) === null || _p === void 0 ? void 0 : _p.departCityList) || '';
                        if ((_r = (_q = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _q === void 0 ? void 0 : _q.departCity) === null || _r === void 0 ? void 0 : _r.locationCity) {
                            const { id: cityId } = yield getCityInfo();
                            locatingCityId = cityId || 1;
                        }
                    }
                    if (((_s = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _s === void 0 ? void 0 : _s.arriveCity) && ((_u = (_t = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _t === void 0 ? void 0 : _t.arriveCity) === null || _u === void 0 ? void 0 : _u.arriveMode) === 2) {
                        arriveCityLimitList = ((_w = (_v = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _v === void 0 ? void 0 : _v.arriveCity) === null || _w === void 0 ? void 0 : _w.arriveCityList) || '';
                    }
                    if (((_x = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _x === void 0 ? void 0 : _x.arriveCity) && ((_z = (_y = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _y === void 0 ? void 0 : _y.arriveCity) === null || _z === void 0 ? void 0 : _z.arriveMode) === 1) {
                        selectedArriveCityId = selectCity;
                    }
                }
            }
            else if (((_0 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeConfig) === null || _0 === void 0 ? void 0 : _0.config) === 2) {
                // 中转城市推荐
                recommendType = 1;
                if (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.transitSuggest) {
                    if ((_1 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.transitSuggest) === null || _1 === void 0 ? void 0 : _1.transitCitySuggest) {
                        const { id: cityId } = yield getCityInfo();
                        locatingCityId = cityId || 1;
                    }
                    transitCityLimitList = ((_2 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.transitSuggest) === null || _2 === void 0 ? void 0 : _2.transitCity) || '';
                    arriveCityLimitList = ((_3 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.transitSuggest) === null || _3 === void 0 ? void 0 : _3.arriveCity) || '';
                    departCityLimitList = ((_4 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.transitSuggest) === null || _4 === void 0 ? void 0 : _4.departCity) || '';
                }
            }
            else if (((_5 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeConfig) === null || _5 === void 0 ? void 0 : _5.config) === 3) {
                // 热门航线推荐
                recommendType = 2;
                if (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.hotLineSuggest) {
                    if ((_6 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.hotLineSuggest) === null || _6 === void 0 ? void 0 : _6.hotLineCitySuggest) {
                        const { id: cityId } = yield getCityInfo();
                        locatingCityId = cityId || 1;
                    }
                    hotLineType = (_7 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.hotLineSuggest) === null || _7 === void 0 ? void 0 : _7.hotLineConfig;
                }
            }
            else if (((_8 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeConfig) === null || _8 === void 0 ? void 0 : _8.config) === 4 || ((_9 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeConfig) === null || _9 === void 0 ? void 0 : _9.config) === 5) {
                // 航司特殊渠道限定报价推荐
                recommendType = (_10 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeConfig) === null || _10 === void 0 ? void 0 : _10.config;
                if (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.cProductCodeList) {
                    if ((_11 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.cProductCodeList) === null || _11 === void 0 ? void 0 : _11.codeList) {
                        cProductCodeList = ((_12 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.cProductCodeList) === null || _12 === void 0 ? void 0 : _12.codeList) || '';
                    }
                }
                if (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeSuggest) {
                    carrierLimitList = ((_13 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeSuggest) === null || _13 === void 0 ? void 0 : _13.carrierList) || '';
                }
            }
            let params = {
                // 行程类型
                tripType: mode,
                // 出发时间
                departDateStart: (_14 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.dataConfig) === null || _14 === void 0 ? void 0 : _14.startDate,
                departDateEnd: (_15 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.dataConfig) === null || _15 === void 0 ? void 0 : _15.endDate,
                backDepartDateStart: (_16 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.dataConfig) === null || _16 === void 0 ? void 0 : _16.backStartDate,
                backDepartDateEnd: (_17 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.dataConfig) === null || _17 === void 0 ? void 0 : _17.backEndDate,
                searchNearLine: ((_18 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeConfig) === null || _18 === void 0 ? void 0 : _18.lateSearch) ? 1 : 0,
                searchSubscribeLine: ((_19 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeConfig) === null || _19 === void 0 ? void 0 : _19.lowPrice) ? 1 : 0,
                recommendType,
                airlineLimitList: (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeSuggest) && ((_20 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.routeSuggest) === null || _20 === void 0 ? void 0 : _20.routeList) || '',
                carrierLimitList,
                departCityLimitList,
                arriveCityLimitList,
                transitCityLimitList,
                householdRecommend: (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) && ((_21 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _21 === void 0 ? void 0 : _21.arriveCity) && ((_23 = (_22 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _22 === void 0 ? void 0 : _22.arriveCity) === null || _23 === void 0 ? void 0 : _23.homeCity) ? 1 : 0,
                residentRecommend: (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) && ((_24 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _24 === void 0 ? void 0 : _24.arriveCity) && ((_26 = (_25 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _25 === void 0 ? void 0 : _25.arriveCity) === null || _26 === void 0 ? void 0 : _26.registeredCity) ? 1 : 0,
                schoolCityRecommend: (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) && ((_27 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _27 === void 0 ? void 0 : _27.arriveCity) && ((_29 = (_28 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _28 === void 0 ? void 0 : _28.arriveCity) === null || _29 === void 0 ? void 0 : _29.schoolCityRecommend) ? 1 : 0,
                coverRecommendCity: (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) && ((_30 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _30 === void 0 ? void 0 : _30.arriveCity) && ((_32 = (_31 = apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.destinationSuggest) === null || _31 === void 0 ? void 0 : _31.arriveCity) === null || _32 === void 0 ? void 0 : _32.coverCityRecommend) ? 1 : 0,
                locatingCityId,
                selectedArriveCityId,
                userId: userInfo && userInfo.userId || '',
                searchSize: (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.count) * (apiConfig === null || apiConfig === void 0 ? void 0 : apiConfig.pageCount),
                quoteType: quoteType,
                hotLineType,
                activityId: isNumeric(ctx._runtimeInfo.pageId) ? ctx._runtimeInfo.pageId : '9999',
                cProductCodeList
            };
            // 检查是否正在请求中，如果是则直接返回
            if (prevRequestParams.current === JSON.stringify(params)) {
                console.log('相同请求正在进行中，跳过本次请求');
                return;
            }
            // 设置请求锁
            prevRequestParams.current = JSON.stringify(params);
            let url = `${currentHost}/homepage/activity/flight/recommend`;
            const res = yield get(url, params);
            // const res = {
            //   singleFlightList: mockData
            // }
            const singleFlightList = [];
            const { data, header, profile, recommendScene, recommendSceneTip } = res, other = __rest(res, ["data", "header", "profile", "recommendScene", "recommendSceneTip"]);
            if (recommendScene && recommendSceneTip) {
                setRecommendScene(recommendScene);
                setRecommendSceneTip(recommendSceneTip);
            }
            else {
                setRecommendScene(0);
                setRecommendSceneTip('');
            }
            if (((_33 = res === null || res === void 0 ? void 0 : res.singleFlightList) === null || _33 === void 0 ? void 0 : _33.length) > 0) {
                res.singleFlightList.forEach((item) => {
                    if (item.forwardDirectFlight) {
                        singleFlightList.push(flightInfoAdapter(item.forwardDirectFlight));
                    }
                });
                setSingleFlightList(singleFlightList);
                setGoFlightList(res.singleFlightList);
                const singleInfoData = (singleFlightList === null || singleFlightList === void 0 ? void 0 : singleFlightList.length) > 0 ? singleFlightList.slice(0, index) : [];
                if (!(singleInfoData.length > 0)) {
                    setIsNowEmpty(true);
                }
                setSingleInfo(singleInfoData);
            }
            else {
                setSingleFlightList([]);
                setGoFlightList([]);
                setSingleInfo([]);
                setIsNowEmpty(true);
            }
            const recommendFlightList = [];
            if (((_34 = res === null || res === void 0 ? void 0 : res.roundFlightList) === null || _34 === void 0 ? void 0 : _34.length) > 0) {
                res.roundFlightList.forEach((item) => {
                    if (item.forwardDirectFlight && item.backwardDirectFlight) {
                        recommendFlightList.push({
                            forwardDirectFlight: item.forwardDirectFlight,
                            backwardDirectFlight: item.backwardDirectFlight,
                            totalPrice: item.totalPrice
                        });
                    }
                });
                setRecommendFlightList(recommendFlightList);
            }
            else {
                setRecommendFlightList([]);
            }
            const transitFlightList = [];
            if (((_35 = res === null || res === void 0 ? void 0 : res.transitFlightList) === null || _35 === void 0 ? void 0 : _35.length) > 0) {
                res.transitFlightList.forEach((item) => {
                    if (item.transitFlight) {
                        transitFlightList.push(Object.assign(Object.assign({}, item.transitFlight), { tripType: item.tripType }));
                    }
                });
                setTransitFlightList(transitFlightList);
            }
            else {
                setTransitFlightList([]);
            }
        }
        catch (error) {
            console.log('error.....', error);
            toast('获取数据失败');
        }
    });
    useEffect(() => {
        console.log('flight-special-price::Effect::selectCity::', selectCity);
        if (selectCity) {
            getGetAPI();
        }
    }, [selectCity]);
    const jump = (item, index) => {
        var _a;
        let lab = {
            departCityCode: item.departCityCode,
            arriveCityCode: item.arriveCityCode,
            departuredate: item.date,
            price: item.price,
            line: index + 1,
            custom: {
                component_name: '机票往返特价组件',
                bu_code: 'traffic',
                // 区分业务BU，按实际业务上报
                depart_city_name: item.departCityName,
                arrive_city_name: item.arriveCityName
            }
        };
        (_a = _LXReport === null || _LXReport === void 0 ? void 0 : _LXReport.mcReport) === null || _a === void 0 ? void 0 : _a.call(_LXReport, CLICK_CARD_MC_BID, {
            valLab: lab
        });
        const filter = [];
        let carriersLimit = '';
        if (apiConfig.routeConfig && (apiConfig.routeConfig.config === 0 || apiConfig.routeConfig.config === 4 || apiConfig.routeConfig.config === 5)) {
            if (apiConfig.routeSuggest) {
                carriersLimit = apiConfig.routeSuggest.carrierList.trim() || '';
            }
        }
        else if (apiConfig.routeConfig && apiConfig.routeConfig.config === 1) {
            if (apiConfig.destinationSuggest) {
                carriersLimit = apiConfig.destinationSuggest.carrierList.trim() || '';
            }
        }
        carriersLimit && carriersLimit.split(',').forEach(info => {
            filter.push({
                typeId: item.backDate ? 'CARRIER' : '7',
                itemId: info
            });
        });
        if (routeConfig_recommendType === 4) {
            if (isMTWX()) {
                navigateTo({
                    url: getFlightOTAUrl(item),
                    _web: {
                        miniProgramNative: true
                    }
                });
            }
            else {
                navigateTo({
                    url: getFlightOTAUrl(item)
                });
            }
        }
        else {
            let query = {
                depart_code: item.departCityCode,
                arrive_code: item.arriveCityCode,
                depart_name: item.departCityName,
                arrive_name: item.arriveCityName,
                depart_pinyin: '',
                arrive_pinyin: '',
                date: item.date || item.flightDate,
                back_date: item.backDate,
                price: item.price,
                discount: item.discout || Math.round(item.discount),
                trafficsource: sourceSwitch,
                extendData: item.extendData,
                filter
            };
            // this.$call(getFlightListUrl(query))
            if (isMTWX()) {
                navigateTo({
                    url: getFlightListUrl(query),
                    _web: {
                        miniProgramNative: true
                    }
                });
            }
            else {
                navigateTo({
                    url: getFlightListUrl(query)
                });
            }
        }
    };
    const resetFoldSingleInfo = () => {
        // 获取折叠展示的列表数据
        if (singleInfo.length > 0 && (uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.isShowFoldDown) && uiSpecial.defaultCount) {
            if (singleInfo.length > uiSpecial.defaultCount) {
                if (!isFoldUp) {
                    setFoldSingleInfo(singleInfo.slice(0, uiSpecial.defaultCount));
                }
                else {
                    setFoldSingleInfo(singleInfo);
                }
            }
            else {
                setFoldSingleInfo(singleInfo);
            }
        }
        else {
            setFoldSingleInfo(singleInfo);
        }
    };
    useEffect(() => {
        resetFoldSingleInfo();
    }, [singleInfo, uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.isShowFoldDown, uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.defaultCount, isFoldUp]);
    useEffect(() => {
        var _a, _b;
        // 只有当用户信息加载完成时才调用API
        if (userInfo.done) {
            setDivSize();
            getGetAPI();
        }
        const tag = {
            custom: {
                component_name: '机票往返特价组件',
                bu_code: 'traffic' // 区分业务BU，按实际业务上报
            }
        };
        console.log('flight-special-price::Effect::添加cityChanged监听');
        (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.on('cityChanged', cityChanged);
        (_b = ctx === null || ctx === void 0 ? void 0 : ctx._LXReport) === null || _b === void 0 ? void 0 : _b.mvReport(FLIGHT_SPECIAL_PRICE_ROOT_MV, {
            valLab: tag
        });
        return () => {
            var _a;
            (_a = ctx === null || ctx === void 0 ? void 0 : ctx._communication) === null || _a === void 0 ? void 0 : _a.off('cityChanged', cityChanged);
        };
    }, [userInfo.done]); // 监听userInfo.done的变化
    return <View>
      <View x-if={mode === 0}>
        <View x-if={singleInfo.length > 0} className={'flight-special-ticket-container'}>
          <View x-if={show && headerConfig.image} className={'block-flight-special-ticket-header'}>
            <LImage className="block-flight-special-ticket-header-img" source={{
        uri: headerConfig.image
    }} style={{
        borderRadius: 0
    }} imageStyle={{
        borderRadius: 0
    }}></LImage>
          </View>
          <View x-if={mode === 0} style={headerStyle}>
            <View x-if={mode === 0} className={'block-flight-special-container'} style={containerStyle}>
              <View x-if={theme !== 4 && titleConfig.title} className={'block-flight-special-container-flex'} style={{
        paddingBottom: '25rpx'
    }}>
                <View className={'block-flight-special-container-title-title-left'} style={{
        backgroundColor: titleConfig.titleLeft
    }}></View>
                <Text className={'block-flight-special-container-flex-title'} style={{
        color: titleConfig.titleColor,
        paddingLeft: '20rpx',
        fontWeight: '500',
        fontSize: '32rpx'
    }}>
                  {titleConfig.title}
                </Text>
                <Text x-if={singleFlightList.length > apiConfig.count} className={'block-flight-special-container-title-switch'} onClick={change} style={{
        color: titleConfig.switchBg
    }}>
                  {titleConfig.switch}
                </Text>
              </View>
              <View x-if={recommendScene !== 0 && recommendSceneTip} className={'block-flight-special-container-scene-tip'}>
                <Text className={'block-flight-special-container-scene-tip-text'} style={{
        color: titleConfig.tipsColor
    }}>
                  {recommendSceneTip}
                </Text>
              </View>
              <View x-if={theme === 2 && singleInfo.length > 0} className={'block-flight-special-container-negative-margin'}>
                <FlightTheme2 data={singleInfo} jump={jump} cornerLabelWord={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelWord} cornerLabelBgColor={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelBgColor} cornerLabelColor={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelColor} cornerLabelImg={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelImg} routeConfig_recommendType={routeConfig_recommendType}/>
              </View>
              
              <View x-if={theme === 7 && singleInfo.length > 0} className={'block-flight-special-container-negative-margin'}>
                <FlightTheme7 data={singleInfo} sourceSwitch={sourceSwitch} cornerLabelWord={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelWord} cornerLabelBgColor={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelBgColor} cornerLabelColor={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelColor} cornerLabelImg={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelImg} routeConfig_recommendType={routeConfig_recommendType} cornerConfig={cornerConfig}/>
              </View>
              
              <View x-if={theme === 3 && singleInfo.length > 0}>
                <FlightTheme3 data={singleInfo} jump={jump} cornerLabelWord={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelWord} cornerLabelBgColor={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelBgColor} cornerLabelColor={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelColor} cornerLabelImg={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelImg}/>
              </View>
              
              <View x-if={theme === 4 && singleInfo.length > 0}>
                <View className={'block-flight-special-container-theme-title'} style={{
        paddingBottom: p2runit(Number((_a = uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.titleBottom) !== null && _a !== void 0 ? _a : 0) / 2)
    }}>
                  <Image className="block-flight-special-container-theme-title-title-img" source={{
        uri: 'https://p1.meituan.net/travelcube/504512718e2b26570c8b9f4e282c05b41861.png'
    }}></Image>
                  <View className={'block-flight-special-container-flex-item block-flight-special-container-theme-title-flex-title'}>
                    {titleConfig.title}
                  </View>
                  <View x-if={titleConfig.switch} className={'block-flight-special-container-theme-title-flex-switch'} onClick={change}>
                    <Text className="block-flight-special-container-theme-title-flex-switch-flex-switch-text">
                      {titleConfig.switch}
                    </Text>
                    <Image className="block-flight-special-container-theme-title-switch-img" source={{
        uri: getSwitchImg
    }}></Image>
                  </View>
                </View>
                <FlightTheme4 purchaserCount={''} data={singleInfo} jump={jump} cornerLabelWord={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelWord} cornerLabelBackup={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelBackup} cornerLabelBgColor={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelBgColor} cornerLabelColor={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelColor} cornerLabelImg={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelImg}/>
              </View>
              <View x-if={theme === 1 || theme === 5 || theme === 6 || theme === 8 || theme === 9} className="block-flight-special-container-card-pics" style={theme === 9 ? {
        width: '750rpx',
        marginLeft: '-20rpx'
    } : {}}>
                
                <View x-if={theme === 1 && singleInfo.length > 0}>
                  <RecyclerView className="block-flight-special-container-pic-list">
                    {singleInfo.map((city, index) => {
        return <RecyclerView.Cell className="block-flight-special-container-card-pics-pic-item" key={index}>
                          <Recommend1 btColor={uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btColor} bgColor={titleConfig.background || 'transparent'} jump={jump} city={city} index={index}/>
                        </RecyclerView.Cell>;
    })}
                  </RecyclerView>
                </View>
                
                <View x-if={theme === 5 && singleInfo.length > 0}>
                  <RecyclerView className="block-flight-special-container-pic-list">
                    {singleInfo.map((city, index) => {
        return <RecyclerView.Cell className="block-flight-special-container-card-pics-pic-item" key={index}>
                          <Recommend2 city={city} index={index} jump={jump} cornerLabelWord={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelWord} cornerLabelBgColor={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelBgColor} cornerLabelColor={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelColor} cornerLabelImg={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelImg}/>
                        </RecyclerView.Cell>;
    })}
                  </RecyclerView>
                </View>
                
                <View x-if={theme === 6 && singleInfo.length > 0}>
                  <RecyclerView className="block-flight-special-container-pic-list">
                    {singleInfo.map((city, index) => {
        return <RecyclerView.Cell className="block-flight-special-container-card-pics-pic-item">
                          <Recommend3 city={city} index={index} jump={jump} cornerLabelWord={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelWord} cornerLabelBgColor={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelBgColor} cornerLabelColor={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelColor} cornerLabelImg={cornerConfig === null || cornerConfig === void 0 ? void 0 : cornerConfig.cornerLabelImg}/>
                        </RecyclerView.Cell>;
    })}
                  </RecyclerView>
                </View>
                
                <View x-if={theme === 8 && foldSingleInfo.length > 0}>
                  <View className="block-flight-special-container-pic-list">
                    {foldSingleInfo.map((city, index) => {
        return <View className="block-flight-special-container-card-pics-pic-item">
                          <Recommend4 jump={jump} city={city} index={index} isTooLong={isNameTooLong} btColor={uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btColor} cornerConfig={cornerConfig}/>
                        </View>;
    })}
                  </View>
                  <View x-if={showBottomBtn} className="block-flight-special-container-bottomBtn">
                    <View className="block-flight-special-container-foldBtn" onClick={showMore} style={bottomBtnStyle}>
                      <Text className="block-flight-special-container-foldBtnTitle" style={{
        color: ((_b = uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btnTitleConfig) === null || _b === void 0 ? void 0 : _b.titleColor) || '#222222',
        fontSize: p2runit(((_d = (_c = uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btnTitleConfig) === null || _c === void 0 ? void 0 : _c.fontSize) !== null && _d !== void 0 ? _d : 0) / 2)
    }}>
                        {getshowMoreTitle}
                      </Text>
                      <Image x-if={(_e = uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btnTitleConfig) === null || _e === void 0 ? void 0 : _e.cornerImg} className={`block-flight-special-container-foldBtnArrow ${isFoldUp ? 'block-flight-special-container-rotate-img' : ''}`} source={{
        uri: (_g = (_f = uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btnTitleConfig) === null || _f === void 0 ? void 0 : _f.cornerImg) !== null && _g !== void 0 ? _g : ''
    }}></Image>
                    </View>
                  </View>
                </View>
                <View x-if={theme === 9 && singleInfo.length > 0}>
                  <View className="block-flight-special-container-scroll-container">
                    <ScrollView horizontal={true} showsHorizontalScrollIndicator={false} style={{
        width: '100%'
    }}>
                      {singleInfo === null || singleInfo === void 0 ? void 0 : singleInfo.map((city, index) => {
        return <View className="block-flight-special-scroll-item" style={{
            marginLeft: index === 0 ? '22rpx' : '12rpx',
            marginRight: index === singleInfo.length - 1 ? '22rpx' : '0rpx'
        }}>
                            <Recommend5 jump={jump} city={city} index={index} btColor={uiSpecial === null || uiSpecial === void 0 ? void 0 : uiSpecial.btColor}/>
                          </View>;
    })}
                    </ScrollView>
                  </View>
                </View>
              </View>
            </View>
          </View>
        </View>
        <View x-elseif={props.showEmpty && isNowEmpty} style={{
        marginTop: '48rpx',
        marginBottom: '48rpx'
    }}>
          <Empty />
        </View>
      </View>
      <View x-if={mode === 1}>
        <FlightRound styles={stylesConfig} jump={jump} titleConfig={titleConfig} apiConfig={apiConfig} singleList={goFlightList} flightList={recommendFlightList}/>
      </View>
      <View x-if={mode === 2}>
        <FlightTransit titleConfig={titleConfig} change={change} list={transitFlightList} jump={jump}/>
      </View>
    </View>;
};
export default memo(MyComponent);
